// extracted by mini-css-extract-plugin
export default {"passwordManagerLayout":"password_passwordManagerLayout__gNlQQ","passwordList":"password_passwordList__Vrr5j","divider":"password_divider__MTXPw"};